/* Auto-generated by generate_creator_lookup_js() — do not edit manually */
window.__NK_CREATORS = {
  "SYDNEY20": {
    "name": "Sydney",
    "quote": "My partner and I have been really enjoying adding it into our evening routine. I definitely feel like I'm getting way more restful sleep.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-sydney20.jpg?v=1772667848",
    "vibe": "chill"
  },
  "NOLA20": {
    "name": "Nola",
    "quote": "I\u2019ve been able to try the sleep gummies, and so far I\u2019m enjoying the experience. As someone that struggles with sleeping, it helps me relax and puts my mind at ease.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-nola20.jpg?v=1772667658",
    "vibe": "chill"
  },
  "WELLNESSWITHLELE": {
    "name": "Lele",
    "quote": "It feels like such a natural fit",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-wellnesswithlele.jpg?v=1772667897",
    "vibe": "chill"
  },
  "OWLEYMOM": {
    "name": "Owley Mom",
    "quote": "We have used the gummies for a few nights and love them",
    "photo": "",
    "vibe": "chill"
  },
  "NEMKO": {
    "name": "Nemko",
    "quote": "I tried the gummies the past two nights and slept great!",
    "photo": "",
    "vibe": "chill"
  },
  "RISHAB20": {
    "name": "Rishab",
    "quote": "",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-rishab20.jpg?v=1772667702",
    "vibe": "chill"
  },
  "LENSCAPASH20": {
    "name": "Ash",
    "quote": "Three was great I slept wonderful.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-lenscapash20.jpg?v=1772667543",
    "vibe": "chill"
  },
  "HANNAH20": {
    "name": "Hannah",
    "quote": "We\u2019ve been using them every night! Both myself and my kids.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-hannah20.jpg?v=1772667401",
    "vibe": "wellness"
  },
  "BLAZE25": {
    "name": "Blaze",
    "quote": "The gummies helped me sleep soooo much that I got up and was talking about them on my TikTok live today. I love how I wake up with energy!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-blaze25.jpg?v=1772667259",
    "vibe": "energetic"
  },
  "SHANNY20": {
    "name": "Shanny",
    "quote": "They\u2019ve definitely been helping me sleep more soundly without that groggy feeling the next morning, which I really appreciate.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-shanny20.jpg?v=1772667786",
    "vibe": "chill"
  },
  "LAURA20": {
    "name": "Laura",
    "quote": "My kids have been using the gummies and really like them, so yay! Excited to share!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-laura20.jpg?v=1772667530",
    "vibe": "wellness"
  },
  "JON20": {
    "name": "Jon",
    "quote": "I\u2019ve taking them a few nights. I like them, bring the heavy eyes to the sleep process.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-jon20.jpg?v=1772667430",
    "vibe": "chill"
  },
  "TIMBER20": {
    "name": "Timber",
    "quote": "They are sooo delicious and I love the effect they have.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-timber20.jpg?v=1772667863",
    "vibe": "energetic"
  },
  "CAITLIN20": {
    "name": "Caitlin",
    "quote": "Slept so well last night with 2 gummies. My partner is sleeping well too.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-caitlin20.jpg?v=1772667295",
    "vibe": "chill"
  },
  "BILLE20": {
    "name": "Bille",
    "quote": "I feel more rested when I wake up each morning. I have only taken two each night before bed- while I still have night wakeups (a preschooler and toddler) I am able to fall back asleep much easier.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-bille20.jpg?v=1772667244",
    "vibe": "chill"
  },
  "CHELSEARHANE": {
    "name": "Chelsea",
    "quote": "They for sure help me sleep at night and I havent ever needed an aid, but helped me wind down faster.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-chelsearhane.jpg?v=1772667327",
    "vibe": "chill"
  },
  "RUTH20": {
    "name": "Ruth",
    "quote": "I love these gummies! They make me feel refreshed and ready to go in the morning without any grogginess.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-ruth20.jpg?v=1772667755",
    "vibe": "energetic"
  },
  "JUDY20": {
    "name": "Judy",
    "quote": "I just started trying out the gummies and it works great.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-judy20.jpg?v=1772667461",
    "vibe": "chill"
  },
  "OLIVIA20": {
    "name": "Olivia",
    "quote": "Liv was able to try your gummies and loved it so much",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-olivia20.jpg?v=1772667674",
    "vibe": "chill"
  },
  "ELIZABETH20": {
    "name": "Elizabeth",
    "quote": "So far I\u2019ve noticed quicker calming and a better sleep experience.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-elizabeth20.jpg?v=1772667356",
    "vibe": "chill"
  },
  "MICHELLE20": {
    "name": "Michelle",
    "quote": "Two full nights sleep after weeks of horrible sleep.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-michelle20.jpg?v=1772667573",
    "vibe": "energetic"
  },
  "EVONNA20": {
    "name": "Evonna",
    "quote": "I actually tried them last night and slept through the night. I like the flavor profile of them, I like the sleep support aspect of them, and so far so good for the first night.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-evonna20.jpg?v=1772667372",
    "vibe": "wellness"
  },
  "JUSTICE20": {
    "name": "Justice",
    "quote": "I did take 4 and the sleep was great!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-justice20.jpg?v=1772667475",
    "vibe": "chill"
  },
  "LONDYN20": {
    "name": "Londyn",
    "quote": "I\u2019ve been taking them consistently for the past week and I\u2019m honestly loving them! They\u2019ve become part of my nightly routine.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-londyn20.jpg?v=1772667558",
    "vibe": "chill"
  },
  "SARA20": {
    "name": "Sara",
    "quote": "I am definitely feeling the difference in my sleep at night. They definitely get a thumbs up from me!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-sara20.jpg?v=1772667770",
    "vibe": "chill"
  },
  "ARIANNA20": {
    "name": "Arianna",
    "quote": "I took 2 last night - I might take 3 tonight and just see what the difference is!\n\nI also took just one today to see if it would help to calm me a bit as it\u2019s\nbeen a very eventful day, and I feel a difference",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-arianna20.jpg?v=1772667229",
    "vibe": "chill"
  },
  "JORDAN20": {
    "name": "Jordan",
    "quote": "I've enjoyed falling asleep faster and staying asleep, I take three per night.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-jordan20.jpg?v=1772667445",
    "vibe": "chill"
  },
  "KYLIEM20": {
    "name": "Kylie",
    "quote": "Thank you so much, we really enjoy it!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-kyliem20.jpg?v=1772667516",
    "vibe": "chill"
  },
  "ALEXIS20": {
    "name": "Alexis",
    "quote": "I thought they tasted great! I did feel more calm and relaxed.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-alexis20.jpg?v=1772667182",
    "vibe": "chill"
  },
  "DEVIN20": {
    "name": "Devin",
    "quote": "",
    "photo": "",
    "vibe": "chill"
  },
  "GRACIE20": {
    "name": "Gracie",
    "quote": "I was having a hard time sleeping through the night before, and now I have been sleeping like a baby!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-gracie20.jpg?v=1772667387",
    "vibe": "wellness"
  },
  "HEIDI20": {
    "name": "Heidi",
    "quote": "",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-heidi20.jpg?v=1772667414",
    "vibe": "chill"
  },
  "SHEREE20": {
    "name": "Sheree",
    "quote": "I love that these gummies gently help you drift to sleep and sleep through the night.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-sheree20.jpg?v=1772667800",
    "vibe": "chill"
  },
  "CHRISTINA20": {
    "name": "Christina",
    "quote": "I tried the gummies a few days ago and had a good experience with them.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-christina20.jpg?v=1772667342",
    "vibe": "chill"
  },
  "KALLIE20": {
    "name": "Kallie",
    "quote": "This one helps with sleep and is great for the whole family!!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-kallie20.jpg?v=1772667491",
    "vibe": "wellness"
  },
  "CARRIE20": {
    "name": "Carrie",
    "quote": "I tried Nawkout twice and I really liked it. The smell and taste are delightful!",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-carrie20.jpg?v=1772667312",
    "vibe": "chill"
  },
  "MICHELLECB20": {
    "name": "Michelle C.",
    "quote": "Honestly I do feel like I\u2019ve been sleeping better.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-michellecb20.jpg?v=1772667589",
    "vibe": "chill"
  },
  "BROOKE20": {
    "name": "Brooke",
    "quote": "",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-brooke20.jpg?v=1772667273",
    "vibe": "chill"
  },
  "STACY20": {
    "name": "Stacy",
    "quote": "I did feel like I got some solid sleep.",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-stacy20.jpg?v=1772667829",
    "vibe": "chill"
  },
  "TORINI20": {
    "name": "Torini",
    "quote": "",
    "photo": "https://cdn.shopify.com/s/files/1/0891/8974/4941/files/creator-torini20.jpg?v=1772667879",
    "vibe": "chill"
  }
};
